import React from 'react';
import {
  NavigationButtonProps,
  NavigationButtons,
  TextArea,
} from '@molecules/index';
import { ErrorMessages } from '@types';
import { ErrorSummary } from '@atoms/ErrorSummary/ErrorSummary';

export interface TextAreaTemplateProps {
  id?: string;
  initialTextValue?: string;
  labelText: string;
  description?: string | JSX.Element;
  errorPath?: string;
  errorMessages?: ErrorMessages[];
  /**
   * max length of characters in the textarea, default is 500 characters
   */
  maxLength?: number;
  /**
   * Show the character counter, default is true
   */
  showCounter?: boolean;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  buttonNext?: NavigationButtonProps;
  buttonPrevious?: NavigationButtonProps;
  isLabelTextTitle?: boolean;
  enableErrorSummary?: boolean;
}

export const TextAreaTemplate: React.FC<TextAreaTemplateProps> = ({
  id,
  initialTextValue,
  labelText,
  description,
  onChange,
  errorPath,
  errorMessages,
  maxLength,
  buttonNext,
  buttonPrevious,
  showCounter,
  isLabelTextTitle = true,
  enableErrorSummary = true,
}) => {
  return (
    <div>
      {enableErrorSummary && <ErrorSummary messages={errorMessages} />}
      <TextArea
        // set to errorPath so that click on the error message can navigate to the correct field
        id={errorPath ?? id}
        labelText={labelText}
        description={description}
        errorPath={errorPath}
        errorMessages={errorMessages}
        onChange={onChange}
        maxLength={maxLength}
        value={initialTextValue}
        showCounter={showCounter}
        isLabelTextTitle={isLabelTextTitle}
      />
      {buttonPrevious && buttonNext ? (
        <NavigationButtons
          buttonNext={buttonNext}
          buttonPrevious={buttonPrevious}
        />
      ) : null}
    </div>
  );
};
